<script>
import { h } from "vue";

/**
 * Tokens destacados no texto corrido dos alertas, na ordem de precedência:
 * dinheiro (R$ 8,8k-24,9k), data ISO, data BR (21/08/2026), percentual,
 * identificadores snake_case/dotted (venda_sem_retencao, fail_safe.enforce)
 * e números com unidade curta (60d, 4x, 24,5k).
 */
const TOKEN_REGEX = new RegExp(
    "(?<![\\w$@/])(?:" +
        [
            "~?R\\$\\s?\\d(?:[\\d.,]*\\d)?(?:k|mi)?(?:\\s?-\\s?(?:R\\$\\s?)?\\d(?:[\\d.,]*\\d)?(?:k|mi)?)?(?!\\w)",
            "\\d{4}-\\d{2}-\\d{2}(?!\\d)",
            "\\d{1,2}/\\d{1,2}(?:/\\d{2,4})?(?!\\d)",
            "~?\\d(?:[\\d.,]*\\d)?%",
            "[A-Za-z][A-Za-z0-9]*(?:_[A-Za-z0-9]+)+(?:\\.[A-Za-z0-9_]+)*\\b",
            "[A-Za-z][A-Za-z0-9_]*(?:\\.[A-Za-z][A-Za-z0-9_]*)+\\b",
            "~?\\d(?:[\\d.,]*\\d)?(?:x|k|d|h|min)?(?!\\w)",
        ].join("|") +
        ")",
    "g",
);

const NUMBER_CLASS =
    "font-medium tabular-nums text-slate-800 dark:text-slate-100";
const FIELD_CLASS =
    "rounded bg-slate-200/60 px-1 py-px font-mono text-[0.85em] text-slate-700 dark:bg-slate-700/60 dark:text-slate-200";

function tokenType(token) {
    if (/^~?R\$/.test(token)) {
        return "number";
    }

    return /^[A-Za-z]/.test(token) ? "field" : "number";
}

export default {
    name: "MonitoringHighlightedText",
    props: {
        text: {
            type: String,
            default: "",
        },
    },

    computed: {
        segments() {
            const text = this.text ?? "";
            const segments = [];
            let cursor = 0;

            for (const match of text.matchAll(TOKEN_REGEX)) {
                if (match.index > cursor) {
                    segments.push({
                        type: "text",
                        text: text.slice(cursor, match.index),
                    });
                }

                segments.push({ type: tokenType(match[0]), text: match[0] });
                cursor = match.index + match[0].length;
            }

            if (cursor < text.length) {
                segments.push({ type: "text", text: text.slice(cursor) });
            }

            return segments;
        },
    },

    render() {
        return h(
            "span",
            this.segments.map((segment) => {
                if (segment.type === "field") {
                    return h("code", { class: FIELD_CLASS }, segment.text);
                }

                if (segment.type === "number") {
                    return h("span", { class: NUMBER_CLASS }, segment.text);
                }

                return segment.text;
            }),
        );
    },
};
</script>
